import { Component } from '@angular/core';
import { DatabaseService } from '../../providers/database.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../providers/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-account',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  public inscription: FormGroup;
  public connexion: FormGroup;
  public vue: string;
  public error: any;

  constructor(public auth: AuthenticationService,
              public store: DatabaseService,
              public formBuilder: FormBuilder,
              private route: ActivatedRoute,
              private router: Router) {

    this.route.params.subscribe(params => {
      this.vue = params['page'];
      if (this.vue === 'inscription') {
        this.getInscription();
      } else {
        this.getConnexion();
      }
    });
  }

  getInscription() {
    this.inscription = this.formBuilder.group({
      email: ['', Validators.email],
      password: ['', Validators.required],
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      company: ['', Validators.required],
      tel: ['', Validators.required],
      poste: ['', Validators.required],
      siret: ['', Validators.required]
    });
  }

  getConnexion() {
    this.connexion = this.formBuilder.group({
      email: ['', Validators.email],
      password: ['', Validators.required]
    });
  }

  login() {
    this.auth.login(this.connexion.value).then(data => {
      this.auth.definedAuthData(true).then(() => {
        if (data['uid'] === this.auth.admin) {
          this.router.navigate(['/admin']);
        } else {
          this.router.navigate(['/account']);
        }
      });
    }).catch( rejected => {
      this.gestionError(rejected);
    });
  }

  register() {
    this.verifyForm(this.inscription.value).then( () => {
      this.auth.register(this.inscription.value).then(data => {
        this.auth.definedAuthData(true).then(() => {
          this.store.setUser(this.inscription.value, data).then(res => {
            this.router.navigate(['/account']);
          });
        });
      }).catch( rejected => {
        this.gestionError(rejected);
      });
    });
  }

  registre() {
    this.router.navigate(['/login/inscription']);
  }

  reset() {
    this.router.navigate(['/reset']);
  }

  gestionError(log: any) {
    switch (log.code) {
      case 'auth/invalid-email':
        this.error = 'Adresse email invalide';
        break;
      case 'auth/wrong-password':
        this.error = 'Mot de passe incorrect';
        break;
      case 'auth/user-not-found':
        this.error = 'L\'adresse email indiqué n\'est pas enregistrer sur le site';
        break;
      case 'auth/weak-password':
        this.error = 'Votre mot de passe doit contenir au moins 6 charactères';
        break;
      case 'auth/email-already-in-use':
        this.error = 'Cette adresse email est déjà utilisée';
        break;
      case 'inscription/invalid-email':
        this.error = log.message;
        break;
      case 'inscription/invalid-password':
        this.error = log.message;
        break;
      case 'inscription/invalid-poste':
        this.error = log.message;
        break;
      case 'inscription/invalid-tel':
        this.error = log.message;
        break;
      case 'inscription/invalid-firstname':
        this.error = log.message;
        break;
      case 'inscription/invalid-lastname':
        this.error = log.message;
        break;
      case 'inscription/invalid-company':
        this.error = log.message;
        break;
      case 'inscription/invalid-siret':
        this.error = log.message;
        break;
      default:
        this.error = 'Une erreur c\'est produite';
        break;
    }
  }

  verifyForm(form: FormGroup) {
    return new Promise((resolve, reject) => {
      if (form['email'] === '') {
        const log = {
          code: 'inscription/invalid-email',
          message: 'Veuillez indiquer votre email'
        };
        this.gestionError(log);
        reject(log.code);
      } else if (form['password'] === '') {
        const log = {
          code: 'inscription/invalid-password',
          message: 'Veuillez indiquer votre mot de passe'
        };
        this.gestionError(log);
        reject(log.code);
      } else if (form['firstname'] === '') {
        const log = {
          code: 'inscription/invalid-firstname',
          message: 'Veuillez indiquer votre prénom'
        };
        this.gestionError(log);
        reject(log.code);
      } else if (form['lastname'] === '') {
        const log = {
          code: 'inscription/invalid-lastname',
          message: 'Veuillez indiquer votre nom'
        };
        this.gestionError(log);
        reject(log.code);
      } else if (form['company'] === '') {
        const log = {
          code: 'inscription/invalid-company',
          message: 'Veuillez indiquer votre entreprise'
        };
        this.gestionError(log);
        reject(log.code);
      } else if (form['poste'] === '') {
        const log = {
          code: 'inscription/invalid-poste',
          message: 'Veuillez indiquer votre poste dans l\'entreprise'
        };
        this.gestionError(log);
        reject(log.code);
      } else if (form['tel'] === '') {
        const log = {
          code: 'inscription/invalid-tel',
          message: 'Veuillez indiquer numéro de téléphone'
        };
        this.gestionError(log);
        reject(log.code);
      } else if (form['siret'] === '') {
        const log = {
          code: 'inscription/invalid-siret',
          message: 'Veuillez indiquer votre siret'
        };
        this.gestionError(log);
        reject(log.code);
      } else {
        resolve();
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/Mustafa/Developpement/noxoe/src/components/login/login.component.ts